import React, { useEffect, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Paper,
  CircularProgress,
} from "@mui/material";
import noCampaign from "../../../shared/assets/icons/No Campaigns.webp";
import style from "../../RFPDashboard/CampaignDetails/Campaign.module.css";

const CampaignTable = ({
  campaignList,
  isSites,
  productAreaSum,
  ongoingLoading,
  initialLoading,
  fetchMore,
  hasMore,
  totalCampaigns,
}) => {
  const containerRef = useRef();

  // Infinite Scroll
  useEffect(() => {
    const handleScroll = () => {
      const container = containerRef.current;
      if (!container || initialLoading || ongoingLoading || !hasMore) return;

      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 200
      ) {
        fetchMore();
      }
    };

    const current = containerRef.current;
    current?.addEventListener("scroll", handleScroll);
    return () => current?.removeEventListener("scroll", handleScroll);
  }, [fetchMore, ongoingLoading, hasMore, initialLoading]);

  const isNoData =
    !initialLoading &&
    !ongoingLoading &&
    (!campaignList || campaignList.length === 0);

  return (
    <Paper
      sx={{ pr: 0, height: 450, padding: 2, boxShadow: 2, borderRadius: 2 }}
    >
      <div className="flex justify-between items-center">
        <h3 className="font-bold text-xl">Ongoing Campaigns</h3>
        <Chip
          label={`Count : ${totalCampaigns || 0}`}
          sx={{ backgroundColor: "#FFD98E", color: "#C77903" }}
        />
      </div>

      <TableContainer
        ref={containerRef}
        component={Paper}
        sx={{
          height: 380, // FIXED → production safe
          overflowY: "auto",
          position: "relative",
        }}
        className={`mt-2 rounded-lg ${style["custom-scrollbar"]}`}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {[
                "Campaign Id",
                "Campaign Name",
                "Client",
                "Total Sites",
                "Total Sq. Ft.",
                "Total Amt.",
                "Status",
              ].map((head) => (
                <TableCell
                  key={head}
                  sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}
                >
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {/* Data Rows */}
            {initialLoading ? (
              <TableRow>
                <TableCell colSpan={7}>
                  <div className="flex justify-center items-center h-[250px]">
                    <CircularProgress size={24} />
                  </div>
                </TableCell>
              </TableRow>
            ) : isNoData ? (
              <TableRow>
                <TableCell colSpan={7}>
                  <div className="flex justify-center items-center h-64">
                    <img src={noCampaign} alt="No Campaign" />
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              campaignList?.map((project, index) => {
                const areaObj = productAreaSum?.find(
                  (ele) => ele.campaignId === project._id
                );
                const siteObj = isSites?.find((ele) => ele._id === project._id);

                return (
                  <TableRow key={project._id || index}>
                    <TableCell>{`${
                      project?.campaignSerialNumber || `Not Available`
                    }`}</TableCell>
                    <TableCell>{project.campaignTitle}</TableCell>
                    <TableCell>
                      {project.organizationId?.name || "Not Available"}
                    </TableCell>
                    <TableCell>{siteObj?.jobCount || 0}</TableCell>
                    <TableCell>
                      {areaObj?.productSum?.toFixed(2) || 0}
                    </TableCell>
                    <TableCell>
                      ₹{" "}
                      {(areaObj?.productTotalAmt || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </TableCell>
                    <TableCell>
                      <Chip
                        label="Ongoing"
                        sx={{ backgroundColor: "#D0F4FF", color: "#093EBC" }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })
            )}

            {/* Infinite Scroll Loading */}
            {ongoingLoading && !initialLoading && (
              <TableRow>
                <TableCell colSpan={7}>
                  <div className="py-3 flex justify-center">
                    <CircularProgress size={24} />
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default CampaignTable;
